import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoindorecab() {



  const cardData =
  {
    keyword: 'Mumbai to Indore Cab ',
    heading: 'Shambhu Cabs: Mumbai to Indore Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Indore Cab services, providing safe, comfortable, and hassle-free travel for families, business travelers, corporate groups, and long-distance commuters heading to Indore. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and pleasant journey from Mumbai to Indore with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, professional chauffeurs, and 24/7 booking support, Shambhu Cabs makes intercity travel convenient and stress-free. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Indore cab services for travelers seeking comfort, safety, punctuality, and a dependable travel experience.',

    top: 'Top Places to Visit in Indore with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Rajwada Palace",
    "description": "Rajwada Palace is a magnificent 7-story heritage structure in the heart of Indore, built by the Holkar dynasty in the 18th century. This palace showcases a perfect blend of Maratha, Mughal, and French architectural styles, with ornate arches, towering balconies, and intricately carved wooden doors. It serves as a symbol of Indore’s royal history and was once the administrative hub of the Holkars. The bustling streets around the palace are filled with local markets, shops, and food stalls, making it both a cultural and historical center of the city."
  },
  {
    "title": "Lal Bagh Palace",
    "description": "Lal Bagh Palace, constructed in the 19th century by Maharaja Tukojirao Holkar II, is a grandiose residence reflecting European architecture with Italian and Victorian influences. Spread over 40 acres, the palace features lavish interiors with crystal chandeliers, ornate mirrors, antique furniture, and portraits of the Holkar family. Its beautifully maintained gardens, marble staircases, and sprawling lawns create a regal ambiance. Visitors get an immersive experience of the Holkar dynasty’s lifestyle and Indore’s royal heritage."
  },
  {
    "title": "Kanch Mandir",
    "description": "Kanch Mandir, or the Glass Temple, is a stunning Jain temple in Indore known for its exquisite glasswork and mirror mosaics. Built in 1903, every wall, ceiling, and pillar of the temple is intricately adorned with glass panels depicting Jain deities, teachings, and symbols. The temple glistens beautifully under sunlight and artificial lighting, creating a mesmerizing spiritual experience. It is not only a place of worship but also an architectural marvel attracting tourists, photographers, and devotees alike."
  },
  {
    "title": "Chhatri Bagh",
    "description": "Chhatri Bagh, also called Holkar Garden, is a serene park featuring beautifully landscaped gardens and royal cenotaphs (chhatris) dedicated to the Holkar rulers. The marble cenotaphs are intricately carved, depicting the grandeur of Maratha architecture. The garden offers peaceful walking paths, fountains, and shaded areas, making it a popular spot for morning walks, photography, and historical exploration. Chhatri Bagh is a perfect blend of heritage, greenery, and tranquility in Indore."
  },
  {
    "title": "Ralamandal Wildlife Sanctuary",
    "description": "Ralamandal Wildlife Sanctuary, located on the outskirts of Indore, is a verdant haven for nature lovers and wildlife enthusiasts. The sanctuary houses leopards, deer, wild boars, and a variety of birds and reptiles. Visitors can enjoy trekking trails, nature walks, and spotting wildlife in their natural habitat. The lush green hills, water bodies, and dense forests provide a peaceful retreat away from the city’s hustle. Ralamandal Sanctuary is ideal for eco-tourism, adventure trips, and educational excursions."
  },
  {
    "title": "Indore Museum (Central Museum)",
    "description": "Indore Museum, also known as the Central Museum, showcases a rich collection of artifacts, sculptures, coins, inscriptions, and paintings representing Madhya Pradesh’s history and culture. Visitors can explore prehistoric relics, Mughal-era sculptures, tribal artifacts, and miniature paintings. The museum also houses displays on the Holkar dynasty and regional folk art. It is an important destination for history enthusiasts, students, and tourists wanting a deeper understanding of Indore’s cultural heritage."
  },
  {
    "title": "Patalpani Waterfall",
    "description": "Patalpani Waterfall, located around 35 km from Indore, is a breathtaking natural spot, especially during the monsoon season when the falls are at their fullest. The waterfall plunges dramatically into a deep gorge, surrounded by lush greenery and forested hills. Visitors can enjoy trekking, picnicking, and photography here. The area provides a refreshing escape from urban life and is popular among adventure seekers, nature lovers, and weekend travelers looking for a scenic retreat near Indore."
  },
  {
    "title": "Gomatgiri Jain Temple",
    "description": "Gomatgiri is a serene hilltop Jain temple complex near Indore, featuring ancient idols, intricately carved marble structures, and panoramic views of the surrounding city and hills. The temple is dedicated to Lord Mahavir and other Jain Tirthankaras. The complex also includes a meditation center, gardens, and peaceful pathways for devotees and tourists. Gomatgiri is both a spiritual and architectural attraction, offering tranquility, religious insights, and scenic beauty in one location."
  },
  {
    "title": "Chappan Dukan",
    "description": "Chappan Dukan, meaning '56 Shops,' is Indore’s famous food street, known for its wide variety of street food and local delicacies. From spicy poha and samosas to sweets like jalebi and gulab jamun, visitors can savor authentic Malwa cuisine here. The vibrant atmosphere, bustling crowd, and aroma of freshly prepared food make it a must-visit spot for culinary enthusiasts. Chappan Dukan not only offers flavors but also a glimpse into Indore’s food culture and lifestyle."
  },
  {
    "title": "Sarafa Bazaar",
    "description": "Sarafa Bazaar, located near Rajwada Palace, is a unique night market where jewelry shops during the day transform into a lively street food haven at night. Visitors can indulge in a variety of local snacks, chaats, sweets, and beverages while exploring the vibrant market ambiance. The combination of cultural shopping, delicious food, and traditional atmosphere makes Sarafa Bazaar a must-visit destination for tourists seeking a quintessential Indore experience."
  }
],




"services": [
  {
    "name": "Mumbai Indore Taxi",
    "description": "Mumbai Indore Taxi offers a comfortable, reliable, and long-distance travel experience between Mumbai and Indore. Covering over 580+ km, this service is ideal for business trips, family tours, personal travel, and urgent travel requirements. With professional chauffeurs, well-maintained vehicles, and smooth highway routing through Nashik or NH48, passengers enjoy a relaxing and safe intercity journey. The service includes door-to-door pickup, flexible timings, multiple food/rest stop options, and punctual travel suitable for all travel needs."
  },
  {
    "name": "One-Way Cab Mumbai Indore",
    "description": "One-Way Cab Mumbai Indore is designed for travelers needing a one-time drop to Indore without a return fare. Perfect for relocations, office joins, student travel, and personal trips, this service ensures economical pricing and complete transparency. Customers benefit from clean cars, dependable chauffeurs, and a smooth trip via the preferred long-route highway."
  },
  {
    "name": "Affordable Cab Mumbai Indore",
    "description": "Affordable Cab Mumbai Indore provides budget-friendly intercity travel without compromising comfort or reliability. This service focuses on economical fares, fuel-efficient vehicles, and professional drivers. Ideal for families, solo travelers, corporate staff, and long-route passengers looking for value-driven travel between Mumbai and Indore."
  },
  {
    "name": "Best Taxi Mumbai Indore",
    "description": "Best Taxi Mumbai Indore offers a premium-quality travel experience with punctual pickup, superior comfort, and highly experienced drivers. This service is preferred by corporate passengers, families, and frequent travelers seeking top-tier reliability. With smooth highway navigation and premium vehicle options, customers enjoy a relaxed, safe, and timely trip."
  },
  {
    "name": "SUV Cab Mumbai Indore",
    "description": "SUV Cab Mumbai Indore provides spacious, comfortable, and powerful SUVs suitable for long-distance road trips. With extra legroom, large boot space, and better stability on highways, SUVs are ideal for large families, group travel, and corporate passengers who need a premium and relaxing journey to Indore."
  },
  {
    "name": "Sedan Cab Mumbai Indore",
    "description": "Sedan Cab Mumbai Indore offers comfortable, smooth, and economical sedans perfect for 2–4 passengers. With superior mileage, quiet cabins, and cushioned seating, sedans ensure a peaceful highway journey. Ideal for business travel, solo passengers, and couples looking for affordable yet comfortable long-distance transport."
  },
  {
    "name": "Outstation Cab Mumbai Indore",
    "description": "Outstation Cab Mumbai Indore provides flexible long-distance travel options including one-way, round-trip, and multi-day cab services. It is suitable for business visits, family vacations, medical travel, and pilgrimages in and around Indore. With expert highway drivers and dependable vehicles, outstation travel becomes convenient and safe."
  },
  {
    "name": "24×7 Mumbai Indore Taxi",
    "description": "24×7 Mumbai Indore Taxi ensures round-the-clock availability for late-night departures, emergency travel, early-morning pickups, and last-minute trip plans. Passengers benefit from secure nighttime highway driving, quick booking confirmation, and trusted chauffeurs trained for long-distance trips at any hour."
  },
  {
    "name": "Corporate Cab Mumbai Indore",
    "description": "Corporate Cab Mumbai Indore is designed for business travelers, executives, teams attending meetings, and corporate partners. It offers premium vehicles, trained chauffeurs, privacy-focused cabins, and punctual transfers. Suitable for companies with frequent intercity travel between Mumbai and Indore."
  },
  {
    "name": "Fast Cab Mumbai Indore",
    "description": "Fast Cab Mumbai Indore ensures quick pickups, optimized highway routing, and faster intercity travel. Designed for urgent meetings, events, emergencies, and last-minute plans, this service provides swift yet safe long-distance travel with expert chauffeurs who know the fastest route options."
  },
  {
    "name": "Premium Cab Mumbai Indore",
    "description": "Premium Cab Mumbai Indore provides luxury sedans, premium SUVs, and chauffeur-driven comfort perfect for elite travelers. With plush interiors, smooth suspension, silent cabins, and high-end facilities, this service is ideal for corporate executives, NRI clients, families, and anyone seeking an upscale travel experience."
  },
  {
    "name": "Safe Cab Mumbai Indore",
    "description": "Safe Cab Mumbai Indore prioritizes passenger safety through sanitized vehicles, GPS-enabled tracking, verified drivers, and disciplined highway driving. Suitable for women travelers, senior citizens, medical travel, and family passengers, this service ensures a secure and trustworthy experience throughout the long route."
  },
  {
    "name": "Family Cab Mumbai Indore",
    "description": "Family Cab Mumbai Indore is ideal for family tours, vacations, and long-distance travel with kids or seniors. With comfortable seating, safe driving, ample luggage space, and flexible stop options, this service ensures a relaxed and enjoyable journey across the Mumbai–Indore route."
  },
  {
    "name": "Express Highway Cab Indore",
    "description": "Express Highway Cab Indore provides faster, smoother, and more efficient travel using the safest and fastest highway routes. Drivers are experienced with expressway conditions, ensuring minimal delays, smooth overtakes, and optimized travel time from Mumbai to Indore."
  },
  {
    "name": "Long Drive Cab Mumbai Indore",
    "description": "Long Drive Cab Mumbai Indore is tailored for extended highway journeys, offering comfortable seats, strong AC performance, steady driving, and expert long-route chauffeurs. It ensures fatigue-free travel for passengers who prefer long scenic road journeys across Maharashtra and Madhya Pradesh."
  },
  {
    "name": "Mumbai Indore Pickup Drop",
    "description": "Mumbai Indore Pickup Drop provides direct point-to-point transfers from any location in Mumbai to any destination in Indore. Ideal for hotel transfers, office visits, family travel, and student relocation, the service guarantees punctuality, convenience, and smooth long-distance travel."
  },
  {
    "name": "Mumbai Indore Car Rental",
    "description": "Mumbai Indore Car Rental offers a wide selection of vehicles including sedans, SUVs, premium cars, and long-route vehicles for one-way or round-trip use. This flexible rental option is perfect for personal travel, vacations, pilgrimages, business tours, and extended multi-city travel plans."
  }
],

"tableData": [
  ["Mumbai Indore Taxi", "One-Way Cab Mumbai Indore"],
  ["Affordable Cab Mumbai Indore", "Best Taxi Mumbai Indore"],
  ["SUV Cab Mumbai Indore", "Sedan Cab Mumbai Indore"],
  ["Outstation Cab Mumbai Indore", "24×7 Mumbai Indore Taxi"],
  ["Corporate Cab Mumbai Indore", "Fast Cab Mumbai Indore"],
  ["Premium Cab Mumbai Indore", "Safe Cab Mumbai Indore"],
  ["Family Cab Mumbai Indore", "Express Highway Cab Indore"],
  ["Long Drive Cab Mumbai Indore", "Mumbai Indore Pickup Drop"],
  ["Mumbai Indore Car Rental", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Indore Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers dependable Mumbai to Indore cab services, ideal for business trips, family travel, and long-distance intercity journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to ensure a smooth and relaxing trip to Indore."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long Highway Routes",
    "WhyChoosedescription": "Our professional drivers are experienced in long-distance travel and well-versed with the Mumbai to Indore route, ensuring safe and timely journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Indore cab booking completely hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, travel assistance, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Outstation Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans designed to match your Mumbai to Indore travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Every cab is thoroughly cleaned and sanitized before each journey to ensure a hygienic and secure travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and smooth service, making your Mumbai to Indore journey comfortable and worry-free."
  }
]





























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Indore cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Indore cab services with experienced and professional drivers.',
  },
  {
    question: 'How can I book a Mumbai to Indore cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Indore cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars ideal for long-distance travel from Mumbai to Indore.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Indore route?',
    answer: 'Yes, our drivers are licensed, trained, and familiar with the Mumbai to Indore route to ensure a smooth and safe journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Indore cab?',
    answer: 'Absolutely. You can choose any pickup location in Mumbai and select a drop-off point anywhere in Indore.',
  },
  {
    question: 'Is the Mumbai to Indore cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Indore cab booking services to suit your travel plans.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mumbai to Indore cab bookings?',
    answer: 'All vehicles undergo regular sanitization, and drivers follow strict hygiene and safety guidelines throughout the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Indore cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and offer corporate billing options.',
  },
  {
    question: 'Is customer support available during the Mumbai to Indore journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you at every step of your Mumbai to Indore travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Verma',
    feedback: 'Our Mumbai to Indore journey with Shambhu Cabs was excellent. The ride was smooth and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shruti Chouhan',
    feedback: 'Highly reliable Mumbai to Indore cab service. Clean car, punctual driver, and a very comfortable long-distance journey.',
    rating: 5,
  },
];
















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Indore Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-indore-cab.jpg",
  "description": "Shambhu Cabs provides safe, reliable, and affordable Mumbai to Indore cab services for one-way or round trips. Book sedans, SUVs, or premium cars for family travel, corporate trips, and long-distance journeys. Enjoy 24×7 service, express highway routes, fast travel, and convenient pickup-drop or car rental from Mumbai to Indore.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-indore-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Indore Cab | Outstation & Corporate Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Indore cab with Shambhu Cabs. Safe, affordable, and comfortable taxi service for one-way or round trips, family travel, corporate trips, and long-distance journeys. Available 24×7 with sedans, SUVs, and premium cars, including pickup-drop and car rental options."
  />

  <meta
    name="keywords"
    content="Mumbai Indore Taxi, One-Way Cab Mumbai Indore, Affordable Cab Mumbai Indore, Best Taxi Mumbai Indore, SUV Cab Mumbai Indore, Sedan Cab Mumbai Indore, Outstation Cab Mumbai Indore, 24×7 Mumbai Indore Taxi, Corporate Cab Mumbai Indore, Fast Cab Mumbai Indore, Premium Cab Mumbai Indore, Safe Cab Mumbai Indore, Family Cab Mumbai Indore, Express Highway Cab Indore, Long Drive Cab Mumbai Indore, Mumbai Indore Pickup Drop, Mumbai Indore Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/25.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoindorecab;